<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
    </customize-page>
    <el-dialog
      :close-on-click-modal="false"
      title="创建退货申报核注单"
      width="1000px"
      :visible.sync="showMakeHeZhuDirectFormFlag"
    >
      <el-form
        ref="form"
        :model="heZhuForm"
        label-width="110px"
        :rules="rules"
        size="mini"
        :inline="true"
        label-position="right"
      >
        <el-form-item label="清单类型" prop="billType">
          <!-- 0：普通清单，1：集报清单，3：先入区后报关，4：简单加工，5：保税展示交易，6：区内流转，7：区港联动，8:保税电商，9：一纳成品内销默认为0：普通清单 -->
          <el-select v-model="heZhuForm.billType">
            <el-option value="0" label="普通清单"></el-option>
            <el-option value="1" label="集报清单"></el-option>
            <el-option value="3" label="先入区后报关"></el-option>
            <el-option value="4" label="简单加工"></el-option>
            <el-option value="5" label="保税展示交易"></el-option>
            <el-option value="6" label="区内流转"></el-option>
            <el-option value="7" label="区港联动"></el-option>
            <el-option value="8" label="保税电商"></el-option>
            <el-option value="9" label="一纳成品内销"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经营企业" prop="bizOpCompanyCode">
          <el-select filterable v-model="heZhuForm.bizOpCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货企业" prop="rcvCompanyCode">
          <el-select filterable v-model="heZhuForm.rcvCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申报企业" prop="dclCompanyCode">
          <el-select filterable v-model="heZhuForm.dclCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="监管方式" prop="tradeMode">
          <el-select filterable v-model="heZhuForm.tradeMode">
            <el-option
              v-for="item in getTradeMode"
              :key="item.value"
              :label="`${item.value}-${item.label}`"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运输方式" prop="transMode">
          <el-select filterable v-model="heZhuForm.transMode">
            <el-option
              v-for="item in getTransMode"
              :key="item.value"
              :label="`${item.value}-${item.label}`"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账册号" prop="emsNo">
          <el-input v-model="heZhuForm.emsNo"></el-input>
        </el-form-item>
        <el-form-item label="起运国" prop="startShipCountry">
          <el-input v-model.number="heZhuForm.startShipCountry"></el-input>
        </el-form-item>
        <el-form-item label="关联账册备案号">
          <el-input v-model="heZhuForm.rltEmsNo"></el-input>
        </el-form-item>
        <el-form-item label="关联清单编号">
          <el-input v-model="heZhuForm.rltInvtNo"></el-input>
        </el-form-item>
        <el-table :data="goods" :border="true" style="margin-bottom: 10px">
          <el-table-column prop="skuName" label="商品备案名称">
          </el-table-column>
          <el-table-column prop="itemNo" label="商品料号" width="150">
          </el-table-column>
          <el-table-column prop="qty" label="数量" width="100">
          </el-table-column>
          <el-table-column prop="unitPrice" label="申报单价" width="100">
            <template slot="header">
              单价
              <a style="font-size: 10px; color: #409eff" @click="copyUnitPrice"
                >(复制)</a
              >
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.unitPrice" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="currency" label="申报币种" width="100">
            <template slot="header">
              币种
              <a style="font-size: 10px; color: #409eff" @click="copyCurrency"
                >(复制)</a
              >
            </template>
            <template slot-scope="scope">
              <el-input-number
                style="width: 100%"
                v-model.number="scope.row.currency"
                size="mini"
                :controls="false"
                :precision="0"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-form-item>
          <el-button type="primary" @click="createHeZhuOrder">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import dandingApi from "@/api/danding";
import heZhuApi from "@/api/heZhuApi";
import { mapGetters } from "vuex";

export default {
  components: {
    CustomizePage
  },
  mixins: [Page],
  mounted() {
    this.fetch();
  },
  computed: {
    ...mapGetters({
      getEECommerce: "getEECommerce",
      getTradeMode: "getTradeMode",
      getTransMode: "getTransMode",
      getCustomerList: "getCustomerList"
    })
  },
  data() {
    return {
      loading: false,
      dataList: [],
      goods: [],
      itemMap: {},
      showMakeHeZhuDirectFormFlag: false,
      heZhuForm: {},
      rules: {
        emsNo: [{ required: true, message: "账册号不能为空", trigger: "blur" }],
        billType: [
          { required: true, message: "清单类型不能为空", trigger: "change" }
        ],
        bizOpCompanyCode: [
          { required: true, message: "请选择经营企业", trigger: "change" }
        ],
        rcvCompanyCode: [
          { required: true, message: "请选择收货企业", trigger: "change" }
        ],
        dclCompanyCode: [
          { required: true, message: "请选择申报企业", trigger: "change" }
        ],
        tradeMode: [
          { required: true, message: "请选择监管方式", trigger: "change" }
        ],
        transMode: [
          { required: true, message: "请选择运输方式", trigger: "change" }
        ],
        startShipCountry: [
          { required: true, message: "请输入起运国代码", trigger: "blur" },
          { type: "number", message: "起运国必须为数字", trigger: "blur" }
        ]
      },
      columns: [
        // {
        //   type: "expand",
        //   render: (h, params) => {
        //     if (!this.itemMap[params.row.id]) {
        //       dandingApi
        //         .loadReturnDeclareOrder({
        //           returnDeclareOrderId: params.row.id
        //         })
        //         .then(res => {
        //           this.itemMap[params.row.id] = res.items;
        //           this.itemMap = { ...this.itemMap };
        //         });
        //     }
        //     return (
        //       <el-table
        //         border
        //         style="width: 100%"
        //         data={this.itemMap[params.row.id]}
        //       >
        //         <el-table-column
        //           align="center"
        //           prop="skuName"
        //           label="商品名称"
        //         ></el-table-column>
        //         <el-table-column
        //           align="center"
        //           prop="itemNo"
        //           label="商品料号"
        //         ></el-table-column>
        //         <el-table-column
        //           align="center"
        //           prop="qty"
        //           label="数量"
        //           width="150"
        //         ></el-table-column>
        //       </el-table>
        //     );
        //   }
        // },
        {
          title: "导入单号",
          key: "importOrderNo",
          align: "center"
        },
        {
          title: "申报状态",
          key: "declareStatus",
          align: "center",
          width: 200,
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              WAIT_DECLARE: ["info", "待申报"],
              DECLARE_SUCCESS: ["success", "申报成功"]
            };
            return (
              <div>
                <el-tag type={tagType[row.declareStatus][0]}>
                  {tagType[row.declareStatus][1]}
                </el-tag>
              </div>
            );
          }
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          align: "center",
          width: 200
        },
        {
          width: 250,
          title: "操作",
          align: "center",
          fixed: "right",
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.jumpToHeZhuList.bind(this, row)}
                >
                  查看核注单
                </a>
                {row.declareState !== "DECLARE_SUCCESS" ? (
                  <a
                    style={{ color: "#409EFF", padding: "0 10px" }}
                    onClick={this.showMakeHeZhuDirectForm.bind(this, row)}
                  >
                    生成核注清单
                  </a>
                ) : (
                  ""
                )}
              </div>
            );
          }
        }
      ],
      filterObj: {
        importOrderNo: "",
        declareStatus: ""
      },
      currentRow: [],
      dialogVisible: false,
      editRow: {}
    };
  },
  methods: {
    createHeZhuOrder() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.$confirm("确定要生成核注清单吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            const request = this.buildHeZhuCreateReq();
            if (request.request.items.every(item => item.qty === 0)) {
              this.$message.error("表体申报数量不能全为0");
              this.loading = false;
              return;
            }
            if (request.request.items.some(item => !item.currency)) {
              this.$message.error("表体币制不能为空");
              this.loading = false;
              return;
            }
            this.loading = true;
            heZhuApi.createByReturnDeclareOrder(request).then(res => {
              if (res.value) {
                this.$message.success("生成核注清单成功");
                this.showMakeHeZhuDirectFormFlag = false;
                this.fetch();
              }
              this.loading = false;
            });
          });
        } else {
          return false;
        }
      });
    },
    buildHeZhuCreateReq() {
      return {
        request: {
          ...this.heZhuForm,
          items: this.goods.map(item => {
            return {
              returnDeclareOrderGoodsId: item.id,
              stockId: item.stockId,
              unitPrice: item.unitPrice ? item.unitPrice.trim() : "",
              currency: item.currency ? item.currency : "",
              qty: item.qty
            };
          })
        }
      };
    },
    copyCurrency() {
      if (this.goods[0].currency) {
        this.goods.forEach(item => {
          this.$set(item, "currency", this.goods[0].currency);
        });
      }
    },
    copyUnitPrice() {
      if (this.goods[0].unitPrice) {
        this.goods.forEach(item => {
          this.$set(item, "unitPrice", this.goods[0].unitPrice);
        });
      }
    },
    showMakeHeZhuDirectForm(row) {
      if (this.heZhuForm.returnDeclareOrderId !== row.id) {
        this.heZhuForm.returnDeclareOrderId = row.id;
        dandingApi
          .loadReturnDeclareOrder({ returnDeclareOrderId: row.id })
          .then(res => {
            this.goods = res.items;
          });
      }
      this.showMakeHeZhuDirectFormFlag = true;
    },
    jumpToHeZhuList(row) {
      this.$router.push({
        path: `/returnDeclareOrder/heZhu/${row.id}`
      });
    },
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      let searchCondition = {
        request: {
          ...filterParams,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        }
      };
      dandingApi
        .returnDeclareOrderPageQuery(searchCondition)
        .then(res => {
          this.loading = false;
          this.dataList = res.items || [];
          this.itemMap = {};
          this.pagination.currentPage = res.pageInfo.currentPage;
          this.pagination.pageSize = res.pageInfo.pageSize;
          this.pagination.totalCount = res.pageInfo.totalCount;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "导入单号",
              model: "importOrderNo",
              type: type.INPUT
            },
            {
              label: "申报状态",
              model: "state",
              type: type.SELECT,
              props: {
                data: [
                  { value: "WAIT_DECLARE", label: "待申报" },
                  { value: "DECLARE_SUCCESS", label: "申报成功" }
                ]
              }
            }
          ]
        }
      ];
    }
  }
};
</script>
